import { useNavigate } from "react-router-dom";
import styled from "styled-components";

import useDisplay from "../../../hooks/useDisplay";

import LSBdH1HeadLine from "../../molecules/text/linSeedKr/Bd/lsBdH1HeadLine";
import LSBdH2HeadLine from "../../molecules/text/linSeedKr/Bd/lsBdH2HeadLine";
import LSRgBody02 from "../../molecules/text/linSeedKr/Rg/lsRgBody02";

function ReviewItem({ data, reviewClicked }) {
  const navigate = useNavigate();
  const { isMobile, isTablet, isDesktop } = useDisplay();
  const isSmall = isMobile || isTablet;

  return (
    <>
      <div
        onClick={() => {
          reviewClicked();
        }}
        style={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
          minWidth: isSmall ? 217 : "100%",
          height: isSmall ? 110 : 153,
          position: "relative",
          background: "#F4FAFF",
          cursor: "pointer",
          borderRadius: 15,
          padding: isSmall ? "18px 24px" : "24px 40px",
          marginRight: isSmall ? 10 : 0,
          backgroundColor: "#fff",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            marginBottom: isSmall ? 6 : 8,
          }}
        >
          <img
            style={{
              width: isSmall ? 12 : 16,
              height: isSmall ? 12 : 16,
              marginRight: isSmall ? 6 : 8,
            }}
            src={"/assets/icons/star_3d.png"}
            alt="star_3d"
          />
          <LSBdH1HeadLine
            style={{
              color: "#101113",
              fontSize: isSmall ? 12 : 16,
              lineHeight: isSmall ? "14.4px" : "22.4px",
            }}
          >
            {data.score.toFixed(1)}
          </LSBdH1HeadLine>
        </div>

        <ReviewTitle
          style={{
            fontSize: isSmall ? 14 : 18,
            lineHeight: isSmall ? "19.6px" : "25.2px",
            marginBottom: isSmall ? 6 : 8,
          }}
        >
          {data.title}
        </ReviewTitle>

        <ReviewContent
          style={{
            color: "#101113",
            fontSize: isSmall ? 12 : 15,
            lineHeight: isSmall ? "14.4px" : "21px",
          }}
        >
          {data.content}
        </ReviewContent>
      </div>
    </>
  );
}

export default ReviewItem;

const ReviewTitle = styled(LSBdH2HeadLine)`
  color: #101113;

  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-word;

  display: -webkit-box;
  -webkit-line-clamp: 1; // 원하는 라인수
  -webkit-box-orient: vertical;
`;

const ReviewContent = styled(LSRgBody02)`
  color: #101113;

  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-word;

  display: -webkit-box;
  -webkit-line-clamp: 2; // 원하는 라인수
  -webkit-box-orient: vertical;
`;
